import type {
  Easing,
  EffectFourDirections,
  SchemaGroup,
  ScrollEffectConfig,
  ScrollEffectParams,
} from '../types';
import {
  range,
  scrollOffsetFull,
  rangeInOut,
  screenLeave,
  screenCenter,
  screenEnter,
  directionFourSides as direction,
  easing,
} from './baseParams';

export interface ShuttersScroll extends ScrollEffectParams {
  direction: EffectFourDirections;
  shutters?: number;
  staggered: number;
  easing?: Easing;
}

const name = 'ShuttersScroll';
const groups: SchemaGroup[] = ['scroll', 'animation'];

export const config: ScrollEffectConfig<ShuttersScroll> = {
  name,
  groups,
  range,
  schema: {
    in: {
      start: { ...screenEnter },
      end: { ...screenCenter },
      shutters: { type: 'number', min: 2, max: 20, default: 12, step: 1 },
      direction,
      staggered: { type: 'boolean', default: true },
    },
    out: {
      start: { ...screenCenter },
      end: { ...screenLeave },
      shutters: { type: 'number', min: 2, max: 20, default: 12, step: 1 },
      direction,
      staggered: { type: 'boolean', default: true },
    },
    continuous: {
      start: { ...screenEnter },
      end: { ...screenLeave },
      shutters: { type: 'number', min: 2, max: 20, default: 12, step: 1 },
      direction,
      staggered: { type: 'boolean', default: true },
    },
  },
  hide: true,
} as const;

export const responsiveConfig: ScrollEffectConfig<ShuttersScroll> = {
  name,
  groups,
  range: { ...rangeInOut },
  schema: {
    in: {
      start: { ...scrollOffsetFull },
      end: { ...scrollOffsetFull, default: 50 },
      shutters: { type: 'number', min: 2, max: 20, default: 8, step: 1 },
      direction,
      staggered: { type: 'boolean', default: false },
      easing: {
        ...easing,
        enum: ['linear', 'cubicInOut', 'sineInOut', 'circInOut'],
        default: 'cubicInOut',
      },
    },
    out: {
      start: { ...scrollOffsetFull, default: 50 },
      end: { ...scrollOffsetFull, default: 100 },
      shutters: { type: 'number', min: 2, max: 20, default: 8, step: 1 },
      direction,
      staggered: { type: 'boolean', default: false },
      easing: {
        ...easing,
        enum: ['linear', 'cubicInOut', 'sineInOut', 'circInOut'],
        default: 'cubicInOut',
      },
    },
  },
  hide: true,
} as const;
